import types from "Screens_old/Schedule/Actions/ActionTypes";
import initialState from "Store/InitialState";

export default function scheduleListReducer(
    state = initialState.scheduleList,
    action
) {
    switch (action.type) {
        case types.LOAD_SCHEDULE_LIST_SUCCESS:
            return action.data;
        case types.DELETE_SCHEDULE_SUCCESS:
            return state.filter((schedule) => schedule.id !== action.data);
        case types.ADD_SCHEDULE_SUCCESS:
            return [action.data, ...state];
        default:
            return state;
    }
}
